package com.solevo.dist

private external interface JsAppConfig {
    val ENV: String
    val ENVIRONMENT_LABEL: String
    val BACKEND_BASE_URL: String
    val FIREBASE_API_KEY: String
    val FIREBASE_AUTH_DOMAIN: String
    val FIREBASE_PROJECT_ID: String
    val FIREBASE_APP_ID: String
    val RECAPTCHA_SITE_KEY: String
    val APP_CHECK_DEBUG_TOKEN: String?
}

private val jsConfig: JsAppConfig
    get() = js("window.__APP_CONFIG__").unsafeCast<JsAppConfig>()

object AppConfig {
    val ENV: String get() = jsConfig.ENV
    val ENVIRONMENT_LABEL: String get() = jsConfig.ENVIRONMENT_LABEL
    val BACKEND_BASE_URL: String get() = jsConfig.BACKEND_BASE_URL

    object Firebase {
        val API_KEY: String get() = jsConfig.FIREBASE_API_KEY
        val AUTH_DOMAIN: String get() = jsConfig.FIREBASE_AUTH_DOMAIN
        val PROJECT_ID: String get() = jsConfig.FIREBASE_PROJECT_ID
        val APP_ID: String get() = jsConfig.FIREBASE_APP_ID
        val RECAPTCHA_SITE_KEY: String get() = jsConfig.RECAPTCHA_SITE_KEY

        /** Only present in non-production configs; absent keys come through as `undefined`. */
        val APP_CHECK_DEBUG_TOKEN: String?
            get() = jsConfig.APP_CHECK_DEBUG_TOKEN?.takeIf { it.isNotBlank() }
    }
}
